var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 23,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-text)",
  d: "M28.492 10.37V8.211h.282l3.542-3.767h2.141L30.4 8.767h-.306zm-1.642 3.002V1.378h1.78v11.994zm5.659 0-3.18-4.21 1.224-1.256 4.146 5.466zM18.793 8.107v5.265h-1.78V4.445h1.707l.016 2.19h-.217q.395-1.2 1.143-1.756.749-.555 1.811-.555.909 0 1.602.386a2.6 2.6 0 0 1 1.079 1.135q.386.757.386 1.868v5.659h-1.78V7.938q0-.974-.506-1.521-.5-.548-1.377-.548-.596 0-1.07.258a1.86 1.86 0 0 0-.74.757q-.274.498-.274 1.223m-5.869 5.265V4.445h1.78v8.927zm.894-10.312a1.12 1.12 0 0 1-.79-.306 1 1 0 0 1-.321-.748q0-.443.322-.75a1.12 1.12 0 0 1 .789-.305q.466 0 .789.306.33.305.33.749 0 .435-.33.748a1.1 1.1 0 0 1-.79.306ZM3.788 13.372V1.378h1.851v10.4h5.45v1.594z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border-strong)",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M1.069 21.628h35.862"
})));
export default SvgLink;